import { useGetBQCountriesQuery } from "src/context/api/ext/api";

const useCountries = () => {
    const { data: countries, isLoading, isFetching } = useGetBQCountriesQuery();
    return { countries, isFetching };
}

export default useCountries;